import React from "react";
import Entrepreneur from "../../assets/image/png/Entrepreneur.png";
const EntrepreneurHero = () => {
  return (
    <div className="py-4 bg-white">
      <div className="position-relative">
        <img
          height={300}
          className="w-100 obj-fit"
          src={Entrepreneur}
          alt="contact_us_image"
        />
        <div className="position-absolute w-100 text-center  tranform_m1">
          <h4 className=" fs_48 ff_raleway fw-bold text-white">
            Kickstart Your Career as a Drone
            <br className="d-md-block d-none"></br>Entrepreneur
          </h4>
        </div>
      </div>
    </div>
  );
};

export default EntrepreneurHero;
